import e from"react";const d=({nodeId:n,children:o})=>e.cloneElement(e.Children.only(o),{id:`viewer-${n}`});export{d as default};
//# sourceMappingURL=Anchorable.js.map
